import React, { ComponentProps, PropsWithChildren } from 'react';
import { Tooltip } from '@fullstory/components';
import { ResourceDisplayPane } from '@fullstory/library-ui';
import { SpecElementBody } from '../SpecElementBody';
import { getMetadata } from '../../utils';
import { allSpecObjectsBySlug, useFetchFsSpec } from '@fullstory/redux';
import { useSelector } from 'react-redux';

interface SpecElementTooltipProps {
  slug: string;
  placement?: ComponentProps<typeof Tooltip>['placement'];
}

export const SpecElementTooltip: React.FC<PropsWithChildren<SpecElementTooltipProps>> = ({
  slug,
  placement = 'right',
  children,
}) => {
  useFetchFsSpec();
  const specObjectsBySlug = useSelector(allSpecObjectsBySlug);
  const specElement = specObjectsBySlug[slug];
  if (!specElement) return null;

  return (
    <Tooltip
      data-component="SpecElementTooltip"
      disablePadding
      placement={placement}
      maxWidth={400}
      variant="light"
      tooltipContent={
        <ResourceDisplayPane tooltip>
          <ResourceDisplayPane.Header label={slug} />
          <ResourceDisplayPane.Body>
            <SpecElementBody slug={slug} />
          </ResourceDisplayPane.Body>
          {/* TODO support 1-N mappings */}
          <ResourceDisplayPane.Footer metadata={getMetadata(specElement.mapping?.metadata)} />
        </ResourceDisplayPane>
      }
    >
      {children}
    </Tooltip>
  );
};
